import userRole from './userRole';

const writeUserRoles = [
    userRole.admin,
    userRole.localAdmin,
    userRole.write
];

export default writeUserRoles;